
const etats = {
    budgnature: "Nature budgétaire",
    billnumber: "N° de facture ou bordereau",
    billdate: "Date de la facture",
    intitule: "Intitule mémoire",
    marketnumber: "N° de marché / bordereau",
}

const billtext = {
    pdl: "PDL",
    energy: "Energie",
    sender: "Fournisseur",
    source: "Source",
    docreference: "N° de facture",
    billdate: "Date de facture",
    begindate: "Date de début",
    enddate: "Date de fin",
    conso: "Consommation",
    ttc: "Montant € TTC",
    pdlcount: "Nombre de PDL",
    unit: "Unité",
    billcount: "Nombre de factures",
    status: "Statut",
    billstate: "Etat de la facture",
    cancellationbill: "Facture d'annulation",
}

const billpagetext = {
    displaymethod: "Affichage",
    energychoice: "Energie",
    yearchoice: "Année",
    shownodata: "Afficher les compteurs sans valeurs"
}

export { etats, billtext, billpagetext };
